import React, { createContext, useContext } from "react";
import { useState } from "react";
import { secondAxios } from "../../../../../api/axios";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { getMrqs } from "./BOMTab/api";

const MCSContext = createContext();

export const useMcsContext = () => useContext(MCSContext);

function MCSContextProvider({ children, plant: isPlant = false }) {
  const { plantId } = useParams();

  const [plant, setPlant] = useState({
    id: plantId ?? "",
    projects: [],
    mrqs: [],
    pos: [],
    srvs: [],

    selectedProject: {},
    selectedDrawings: [],
    selectedMrq: {},
    selectedBidMrq: {},
    selectedPo: {},
    estData: [],
  });

  const [mcsCurrentTab, setMcsCurrentTab] = React.useState(1);
  const [mrqList, setMrqList] = React.useState([]);

  const [bidData, setBidData] = React.useState([]);
  const [BidTableRows, setBidTableRows] = React.useState([]);

  const [selectedMrqMaterials, setSelectedMrqMaterials] = React.useState([]);

  const [state, setState] = useState({
    loading: false,
    isError: false,
  });

  const fetchPlant = async () => {
    try {
      setState({ isLoading: true, isError: false });
      const res = await secondAxios.get("/plant/" + plantId + "/mcs");

      setPlant({ ...plant, ...res.data });
    } catch (err) {
      console.error("Error fetching plants:", err);
      setState({ isLoading: false, isError: true });
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const fetchMrqList = async () => {
    await getMrqs({ plantId: plant.id }).then((res) => {
      setMrqList(res);
    });
  };

  useEffect(() => {
    isPlant && fetchPlant();
    fetchMrqList();
  }, []);

  const setSelectedDrawings = (drawings) => {
    setPlant({ ...plant, selectedDrawings: drawings });
  };

  console.log({ plant });
  const setSelectedMrqData = (mrq) => {
    setPlant({ ...plant, selectedMrq: {} });
    setPlant({ ...plant, selectedMrq: mrq });
  };

  const setSelectedBidMrqData = (mrq) => {
    setPlant({ ...plant, selectedBidMrq: {} });
    setPlant({ ...plant, selectedBidMrq: mrq });
  };

  const setSelectedPoManager = (po) => {
    setPlant({ ...plant, selectedPo: {} });
    setPlant({ ...plant, selectedPo: po });
  };

  const updatePlantAfterCreateMrq = (res) => {
    // console.log({ res });
    setPlant({
      ...plant,
      selectedDrawings: res.drawings,
      selectedMrq: res.mrq,
    });
  };

  useEffect(() => {
    const newEstData = [];

    (plant?.projects || [])?.forEach((project) => {
      const estTables =
        project &&
        project?.revisions?.[0]?.data?.estimationTable &&
        Object.values(project?.revisions?.[0]?.data?.estimationTable);

      let SummaryData = [];

      estTables?.forEach((table) => {
        if (table?.Summary) {
          table.Summary.forEach((row) => {
            console.log("row", row);
            const totalCost = Number(row.procuredQty) * Number(row.unitCost);
            const frac = (Number(row.pmBudgetedCost) * totalCost) / 100;

            const budgetedCost = totalCost + frac;

            SummaryData.push({
              ...row,
              description: row.MaterialDescription,
              budgetedCost,
              totalCost,
            });
          });
        }
      });

      plant?.id === "b757a170-d0f7-4b11-b01e-7f2584161495" &&
        console.log("SummaryData", SummaryData);

      newEstData.push(...SummaryData);
    });

    setPlant((prev) => ({ ...prev, estData: newEstData }));
  }, [plant?.projects]);

  return (
    <MCSContext.Provider
      value={{
        mcsCurrentTab,
        setMcsCurrentTab,
        isPlant,
        plant,
        setPlant,
        setSelectedDrawings,
        setSelectedMrqData,
        setSelectedPoManager,

        mrqList,
        setMrqList,

        selectedMrqMaterials,
        setSelectedMrqMaterials,
        updatePlantAfterCreateMrq,

        setSelectedBidMrqData,

        bidData: bidData ? bidData : [],
        setBidData,
        BidTableRows,
        setBidTableRows,
        estData: plant.estData,
      }}
    >
      {children}
    </MCSContext.Provider>
  );
}

export { MCSContextProvider, MCSContext };
